export default __webpack_public_path__ + "static/media/sort-up.59591e56.svg";